import { useMemo } from 'react';
import { RiskKeys } from '@components/EntityDrawers/drawers/Risk/keys';
import ControlledTextFieldSelect from '@components/Inputs/controllers/ControlledTextFieldSelect';
import { useProject } from '@context/Project/ProjectProvider';
import useProjectSettings from '@hooks/useProjectSettings';
import { transformArrayToOptions } from '@utils/helpers';
import { settingsRowToString } from '@views/ProjectSettings/components/ProjectDetailsSettings/helpers/helpers';

const RiskActionDropdown = () => {
  const { viewOnly } = useProject();

  const {
    settings: { risk_action },
  } = useProjectSettings();

  const options = useMemo(
    () => transformArrayToOptions((risk_action ?? []).map(settingsRowToString)),
    [risk_action],
  );

  return (
    <ControlledTextFieldSelect
      name={RiskKeys.RiskAction}
      label="Risk action"
      placeholder="Choose risk action"
      disabled={viewOnly}
      options={options}
      resetOnDoubleClick
      required
    />
  );
};

export default RiskActionDropdown;
